// DEMO ONLY — remove with the role preview switcher when Okta role switching
// becomes authoritative end-to-end. Production servers ignore this header.

const ROLE_KEY = "ripple.demoRolePreview";
const CONTROLLER_KEY = "ripple.demoRolePreviewController";
const CLIENT_ROLE_KEY = "ripple.clientRolePreview";
const VALID_ROLES = new Set(["admin", "editor", "viewer"]);
const FETCH_PATCH_KEY = "__rippleDemoRoleFetchPatched";

function storage() {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function getDemoRolePreview() {
  const store = storage();
  const role = store?.getItem(ROLE_KEY) ?? null;
  if (role === "view_limited") {
    store.setItem(ROLE_KEY, "viewer");
    return "viewer";
  }
  return VALID_ROLES.has(role) ? role : null;
}

export function setDemoRolePreview(role, controllerRole) {
  if (!VALID_ROLES.has(role)) return false;
  const store = storage();
  if (!store) return false;
  store.setItem(ROLE_KEY, role);
  if (controllerRole === "admin") {
    store.setItem(CONTROLLER_KEY, "admin");
  }
  return true;
}

export function isAdminDemoRolePreview() {
  return storage()?.getItem(CONTROLLER_KEY) === "admin";
}

// UI-only preview; server identity stays the signed-in user.
// Keep the in-app role preview separate from ROLE_KEY, which
// remains reserved for the existing development X-Dev-Role transport.
export function getClientRolePreview() {
  const store = storage();
  const role = store?.getItem(CLIENT_ROLE_KEY) ?? null;
  return VALID_ROLES.has(role) ? role : null;
}

export function setClientRolePreview(role) {
  if (!VALID_ROLES.has(role)) return false;
  const store = storage();
  if (!store) return false;
  store.setItem(CLIENT_ROLE_KEY, role);
  return true;
}

export function clearClientRolePreview() {
  storage()?.removeItem(CLIENT_ROLE_KEY);
}

function isSameOriginApiRequest(input) {
  const rawUrl = typeof input === "string" || input instanceof URL
    ? String(input)
    : input?.url;
  if (!rawUrl || typeof window === "undefined") return false;
  const url = new URL(rawUrl, window.location.href);
  return url.origin === window.location.origin && url.pathname.startsWith("/api/");
}

export function installDemoRolePreviewFetch() {
  if (!import.meta.env.DEV || typeof window === "undefined" || window[FETCH_PATCH_KEY]) return;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const role = getDemoRolePreview();
    if (!role || !isSameOriginApiRequest(input)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(init.headers).forEach((value, key) => headers.set(key, value));
    headers.set("X-Dev-Role", role);
    return originalFetch(input, { ...init, headers });
  };
  window[FETCH_PATCH_KEY] = true;
}